import { useEffect } from 'react'
import { useRouter } from 'next/router'

export default function Home() {
  const router = useRouter()
  useEffect(() => {
    const qs = window.location.search
    router.replace(`/candidate${qs}`)
  }, [router])
  return null
}
